<div class="slider-container">

  {{#if header}}
    <div class="header {{header_class}}">{{t header}}</div>
  {{/if}}

  <ul>
    {{#each sliders}}
      <li class="slider-wrapper {{#if vertical}}slider-wrapper-vertical{{/if}}">

      {{#if enable_step_buttons}}
        <button class="slider-step minus"
                data-subject="{{subject}}"
                data-change="decrement"
                aria-label="{{t 'slider.decrementBtn'}}">
        </button>
      {{/if}}

      {{#with labels}}
        {{#if min}}
          {{> label description=min}}
        {{else}}
          {{> label description=../min}}
        {{/if}}
      {{/with}}

      <div id="{{../cid}}-{{subject}}"
           data-title="{{t header}}"
           data-subject="{{subject}}"
           class="slider {{#if vertical}}slider-vertical{{/if}} {{class}}">

        {{#each points}}
          <div class="slider-index-{{@index}} slider-position">
            <span class="icon"></span>
            {{#if description}}<span class="text">{{t description }}</span>{{/if}}
          </div>
        {{/each}}
        <input type="range" max="0" value="0" {{#if vertical}}orient="vertical"{{/if}}/>
        <span class="slider-thumb-{{#if vertical}}vertical{{else}}horizontal{{/if}}"></span>
      </div>

      {{#with labels}}
        {{#if max}}
          {{> label description=max}}
        {{else}}
          {{> label description=../max}}
        {{/if}}
      {{/with}}

      {{#if enable_step_buttons}}
        <button class="slider-step plus" data-subject="{{subject}}" data-change="increment" aria-label="{{t 'slider.incrementBtn'}}"></button>
      {{/if}}
      </li>
    {{/each}}
  </ul>
</div>
